<template>
  <Catalog
    title="Группа заявок"
    name-label="Название группы"
    submit-error="Укажите название группы заявок."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="createId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "TaskGroup",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    createId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getTaskGroupById(id);
    },
    async putData(data) {
      return await this.putTaskGroup(data);
    },
    async postData(data) {
      return await this.postTaskGroup(data);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Catalogs/TaskGroups/TaskGroup.vue